import { entryTransformersMap } from './entryTransformersMap';
import React from 'react';
import { ArticleRichTextLayoutBlockStyleProps } from './ArticleRichTextLayoutBlock/ArticleRichTextLayoutBlock';
import { LoadingSkeletonProps } from '@jbhi-fi/components/src/LoadingSkeleton/Base/Base';
import { LoadingSkeleton } from '@jbhi-fi/components/src/LoadingSkeleton/LoadingSkeleton';

export class ContentfulEntry {
  private readonly _transformer: (entity: any) => any;
  private readonly _OutputComponent?: React.FC<any>;
  private readonly _layoutBlockProps:
    | ArticleRichTextLayoutBlockStyleProps
    | ((entry: any) => ArticleRichTextLayoutBlockStyleProps);

  public rawEntity: any;
  public loadingProps: LoadingSkeletonProps;

  constructor(entity: Record<string, any>) {
    this.rawEntity = entity?.data?.target ?? entity;

    const entryTransformer = entryTransformersMap.get(this.type);

    const {
      transformer = (e: any) => e,
      OutputComponent = undefined,
      loadingProps = {},
      layoutBlockProps = {},
    } = entryTransformer
      ? typeof entryTransformer === 'object'
        ? entryTransformer
        : entryTransformer(this.rawEntity)
      : {};

    this._OutputComponent = OutputComponent;
    this._transformer = transformer ?? (entity => entity);
    this.loadingProps = loadingProps;
    this._layoutBlockProps = layoutBlockProps;
  }

  get fields(): Record<string, any> {
    return this.rawEntity?.fields;
  }

  get isLoading(): boolean {
    return !this.fields;
  }

  get layoutBlockProps(): ArticleRichTextLayoutBlockStyleProps {
    if (typeof this._layoutBlockProps === 'function') {
      return this._layoutBlockProps(this.rawEntity);
    }
    return this._layoutBlockProps;
  }

  get componentProps(): any {
    if (this.isLoading) return this.loadingProps;
    return this._OutputComponent ? this._transformer(this.rawEntity) : {};
  }

  get OutputComponent(): React.VFC {
    if (this.isLoading) return LoadingSkeleton.Box;
    return this._OutputComponent ?? React.Fragment;
  }

  get id(): string {
    return this.rawEntity?.sys?.id;
  }

  get type(): string {
    if (this.rawEntity?.sys?.type !== 'Entry') return this.rawEntity?.sys?.type;
    return this.rawEntity?.sys?.contentType?.sys?.id;
  }
}
